import { render, staticRenderFns } from "./OverviewCourseDays.vue?vue&type=template&id=5b24653e&scoped=true&"
import script from "./OverviewCourseDays.vue?vue&type=script&lang=js&"
export * from "./OverviewCourseDays.vue?vue&type=script&lang=js&"
import style0 from "./OverviewCourseDays.vue?vue&type=style&index=0&id=5b24653e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b24653e",
  null
  
)

export default component.exports